
function getNextWeekSameDayAndTime({dayOfWeek, hour, minute}) {
    // Şu anki tarihi alın
    const now = new Date();

    // Haftanın bugünkü gününü al (0: Pazar, 1: Pazartesi, ..., 6: Cumartesi)
    const currentDayOfWeek = now.getDay();

    // Hedef günü bugüne göre hesapla
    const dayDifference = (dayOfWeek - currentDayOfWeek + 7) % 7; // Negatif değerleri pozitif yapmak için +7 ve %7
    const targetDate = new Date(now);
    targetDate.setDate(now.getDate() + dayDifference); // Hedef tarihi ayarla

    // Yıl, ay, gün, saat, dakika, saniye ve milisaniyeleri ayarla
    const year = targetDate.getFullYear();
    const month = (targetDate.getMonth() + 1).toString().padStart(2, '0'); // Aylar 0 tabanlıdır
    const date = targetDate.getDate().toString().padStart(2, '0');
    const formattedHour = hour.toString().padStart(2, '0');
    const formattedMinute = minute.toString().padStart(2, '0');

    // Formatlanmış tarih string'ini döndür
    return `${year}-${month}-${date}T${formattedHour}:${formattedMinute}:00.000`;
}

export default getNextWeekSameDayAndTime